import React, { useState } from 'react';
import { getDocument } from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

function OcrReader() {
    const [extractedText, setExtractedText] = useState('');
    const [extracted, setExtracted] = useState({});
    const [loading, setLoading] = useState(false);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        setExtractedText('');
        setExtracted({});

        const reader = new FileReader();

        reader.onload = async () => {
            const pdfData = new Uint8Array(reader.result);
            const pdf = await getDocument({ data: pdfData }).promise;
            let fullText = '';

            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const content = await page.getTextContent();
                const pageText = content.items.map(item => item.str).join(' ');
                fullText += pageText + '\n\n';
            }

            setExtractedText(fullText);
            extractSavInfo(fullText);
            setLoading(false);
        };

        reader.readAsArrayBuffer(file);
    };

    const extractSavInfo = (text) => {
        const results = {};

        const patterns = {
            email: /([a-z0-9._%+-]+(?:\s?@\s?)[a-z0-9.-]+(?:\s?\.\s?[a-z]{2,}))/i,

            telephone: /(?:T[ée]l[ée]phone|Portable)?\s*[:–\-]?\s*([\d\s]{10,})/i,

            assureur: /Assureur(?:\s+DO)?\s*[:\-]?\s*([A-Z0-9\s\-]+)/i,

            police: /(?:Police|N[°º]\s?de\s?contrat(?:\s?DO)?)\s*[:\-]?\s*([A-Z0-9]+)/i,

            dossier: /(?:Sinistre|Dossier|Réf[.]?)\s*DO\s*[:\-]?\s*([A-Z0-9/]+)/i,

            reference_expert: /Réf(?:[ée])?[.]?\s*Expert\s*[:\-]?\s*([A-Z0-9]+)/i,
            reference_ixi: /Réf(?:[ée])?[.]?\s*IXI\s*[:\-]?\s*([A-Z0-9\s/]+)/i,
            reference_crac: /Réf(?:[ée])?[.]?\s*e\s*-\s*CRAC\s*[:\-]?\s*(CRAC\d{6,})/i,

            assistant: /Assistante?\s*:?\s*(?:Madame|Monsieur)?\s*([A-Z][a-z]+ [A-Z][a-z]+)/i,

            souscripteur: /Souscripteur\s*:\s*([A-Z\s\-]+(?:LORMONT|BORDEAUX|SAINTES)?)/i,
            beneficiaire: /B[ée]n[ée]ficiaire\s*:\s*([A-Z\s\-]+(?:LORMONT|BORDEAUX|SAINTES)?)/i,

            date_doc: /DOC\s*[:\-]?\s*(\d{2}\/\d{2}\/\d{4})/,
            date_courrier: /(?:BORDEAUX|SAINTES).{0,20}le\s*(\d{1,2}[\/\s]\w+[\/\s]\d{4})/i,

            objet: /Objet\s*[:\-]?\s*(.+?)(?=\s+(Monsieur|Madame))/i,

            date_convocation: /(?:le\s+)?((?:lundi|mardi|mercredi|jeudi|vendredi|samedi|dimanche)\s+\d{1,2}\s+\w+\s+\d{4})\s+(?:à|a)\s+(\d{1,2}h\d{2})/i,

            lieu_convocation: /à l[’']?adresse suivante\s*:\s*(.+?,\s*\d{5}\s+[A-Z]+)/i,

            lieu_sinistre: /Lieu du sinistre\s*[:\-]?\s*(.+?)\s*\d{5}/i,

            adresse: /(\d{1,5}\s+[^,\n]+,\s*\d{5}\s+[A-Z]+)/,
            reference: /Réf\.\s*(?:Expert|E-CRAC)\s*([A-Z0-9\-]+)/i,
            expert_nom: /Dossier suivi par\s+([A-Z][a-z]+\s+[A-Z][a-z]+)/i,
        };



        for (const key in patterns) {
            const match = text.match(patterns[key]);
            if (match) results[key] = match[2] || match[1];
        }

        setExtracted(results);
    };

    return (
        <div className="flex flex-col items-center gap-4 w-full">
            <input type="file" accept="application/pdf" onChange={handleFileChange} />

            {loading && (
                <div className="w-full text-gray-500 text-sm">
                    Analyse PDF en cours…
                </div>
            )}

            {extractedText && (
                <div className="bg-gray-100 p-3 rounded w-full max-h-40 overflow-y-auto text-gray-700 text-sm whitespace-pre-wrap">
                    {extractedText}
                </div>
            )}

            {Object.keys(extracted).length > 0 && (
                <div className="bg-white shadow p-4 border rounded w-full">
                    <h3 className="mb-2 font-semibold">Données extraites :</h3>
                    <ul className="space-y-1 text-sm">
                        {Object.entries(extracted).map(([key, value]) => (
                            <li key={key}>
                                <strong>{key} :</strong> {value}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default OcrReader;
